import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SvgIcon from '@mui/material/SvgIcon';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import { tokens } from 'src/locales/tokens';
import { paths } from 'src/paths';
import { Inventory, ReportOutlined, Restaurant, Settings } from '@mui/icons-material';
import { DataHelper } from 'src/services/dataHelper';
import Mail04Icon from 'src/icons/untitled-ui/duocolor/mail-04';
import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';

export const useSections = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      {
        items: [
          {
            title: t(tokens.nav.dashboard),
            path: paths.dashboard.index,
            icon: (
              <SvgIcon fontSize="small">
                <HomeSmileIcon />
              </SvgIcon>
            )
          },

          //settings
          {
            title: t(tokens.nav.commonSetting),
            path: paths.dashboard.country.index,
            icon: (
              <SvgIcon fontSize="small">
                <Settings />
              </SvgIcon>
            ),
            items: [
              {
                title: t(tokens.nav.user),
                path: paths.dashboard.user.userList
              },
              {
                title: t(tokens.nav.store),
                path: paths.dashboard.store.storeList
              },
              {
                title: t(tokens.nav.country),
                path: paths.dashboard.country.index
              },
              {
                title: t(tokens.nav.region),
                path: paths.dashboard.region.regionList
              },
              {
                title: t(tokens.nav.tax),
                path: paths.dashboard.tax.taxList
              },

              {
                title: t(tokens.nav.location),
                path: paths.dashboard.location.locationList
              },
              {
                title: t(tokens.nav.paymentType),
                path: paths.dashboard.paymentType.paymentTypeList
              },
              {
                title: t(tokens.nav.expensesType),
                path: paths.dashboard.expensesType.expensesTypeList
              },
              {
                title: t(tokens.nav.receivedType),
                path: paths.dashboard.receivedType.receivedTypeList
              },
              {
                title: t(tokens.nav.loyaltyPoint),
                path: paths.dashboard.loyaltyPoint.loyaltyPointList
              },
              {
                title: t(tokens.nav.giftCard),
                path: paths.dashboard.giftCard.giftCardList
              },
              {
                title: t(tokens.nav.promotionDiscount),
                path: paths.dashboard.discount.discountList
              },

            ]
          },

          // restaurant
          {
            title: t(tokens.nav.inventory),
            path: paths.restaurant.menuCategory.index,
            icon: (
              <SvgIcon fontSize="small">
                <Inventory />
              </SvgIcon>
            ),
            items: [
              {
                title: t(tokens.nav.unit),
                path: paths.restaurant.unit.unitList
              },
              {
                title: t(tokens.nav.menuCategory),
                path: paths.restaurant.menuCategory.menuCategoryList
              },

              {
                title: t(tokens.nav.attributesValues),
                path: paths.restaurant.attributes.attributesList
              },

              {
                title: t(tokens.nav.item),
                path: paths.restaurant.menu.menuList
              },
              {
                title: t(tokens.nav.products),
                path: paths.restaurant.product.productList
              },
              // {
              //   title: t(tokens.nav.floorTable),
              //   path: paths.restaurant.floor.floorList
              // },
              {
                title: t(tokens.nav.promotionReward),
                path: paths.restaurant.promotionReward.promotionRewardList
              },
              {
                title: t(tokens.nav.loyaltyPointRewardItem),
                path: paths.restaurant.loyaltyPointReward.loyaltyPointRewardList
              },
            ]
          },

          //customer------------
          {
            title: t(tokens.nav.customer),
            path: paths.restaurant.customerCategory.index,
            icon: (
              <SvgIcon fontSize="small">
                <Users03Icon />
              </SvgIcon>
            ),
            items: [
              {
                title: t(tokens.nav.customerCategory),
                path: paths.restaurant.customerCategory.customerCategoryList
              },
              {
                title: t(tokens.nav.customer),
                path: paths.restaurant.customer.customerList
              },
              {
                title: t(tokens.nav.custGiftCard),
                path: paths.restaurant.custGiftCard.custGiftCardList
              },

            ]
          },

          //Sales Reports------------
          {
            title: t(tokens.nav.salesReports),
            path: paths.restaurant.salesReports.index,
            icon: (
              <SvgIcon fontSize="small">
                <ReportOutlined />
              </SvgIcon>
            ),
            items: [
              {
                title: t(tokens.nav.salesByDay),
                path: paths.restaurant.salesReports.salesByDay
              },
              {
                title: t(tokens.nav.salesByCategory),
                path: paths.restaurant.salesReports.salesByCategory
              },
              {
                title: t(tokens.nav.salesByMenu),
                path: paths.restaurant.salesReports.salesByMenu
              },
              {
                title: t(tokens.nav.salesByPaymentType),
                path: paths.restaurant.salesReports.salesByPaymentType
              },
              {
                title: t(tokens.nav.salesByInvoice),
                path: paths.restaurant.salesReports.salesByInvoice
              },

              {
                title: t(tokens.nav.salesByCustomer),
                path: paths.restaurant.salesReports.salesByCustomer
              },
              {
                title: t(tokens.nav.salesByCashier),
                path: paths.restaurant.salesReports.salesByCashier
              },
              {
                title: t(tokens.nav.salesByDineIn),
                path: paths.restaurant.salesReports.salesByDineIn
              },
              {
                title: t(tokens.nav.cashierInOutReports),
                path: paths.restaurant.salesReports.cashierInOutReports
              },
            ]
          },
          {
            title: t(tokens.nav.contact),
            path: paths.contact,
            icon: (
              <SvgIcon fontSize="small">
                <Mail04Icon />
              </SvgIcon>
            )
          },

        ]
      },
    ];
  }, [t]);
};
